import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatEevnText } from '../../utils/formatEevnText';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Privacy.css';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-page">
      <Header />
      <section className="privacy section">
        <div className="container">
          <h1 className="privacy-title">{t('privacy.title')}</h1>
          <p className="privacy-last-updated">
            <strong>{t('privacy.lastUpdated')}</strong> {new Date().toLocaleDateString()}
          </p>
          
          <div className="privacy-content">
            <section className="privacy-section">
              <h2>{t('privacy.dataController.title')}</h2>
              <p>{formatEevnText(t('privacy.dataController.content'))}</p>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.dataCollection.title')}</h2>
              <p>{t('privacy.dataCollection.content')}</p>
              <ul>
                <li>{t('privacy.dataCollection.item1')}</li>
                <li>{t('privacy.dataCollection.item2')}</li>
                <li>{t('privacy.dataCollection.item3')}</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.dataUsage.title')}</h2>
              <p>{t('privacy.dataUsage.content')}</p>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.dataStorage.title')}</h2>
              <p>{t('privacy.dataStorage.content')}</p>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.dataRetention.title')}</h2>
              <p>{t('privacy.dataRetention.content')}</p>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.userRights.title')}</h2>
              <p>{t('privacy.userRights.content')}</p>
              <ul>
                <li>{t('privacy.userRights.item1')}</li>
                <li>{t('privacy.userRights.item2')}</li>
                <li>{t('privacy.userRights.item3')}</li>
                <li>{t('privacy.userRights.item4')}</li>
                <li>{t('privacy.userRights.item5')}</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.dataSecurity.title')}</h2>
              <p>{t('privacy.dataSecurity.content')}</p>
            </section>

            <section className="privacy-section">
              <h2>{t('privacy.contact.title')}</h2>
              <p>{t('privacy.contact.content')}</p>
            </section>
          </div>

          <div className="privacy-back">
            <Link to="/" className="btn-back">
              {t('privacy.backToHome')}
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Privacy;

